import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ReelsData, TrackingParameters } from './reels-models';
import { AbstractComponent } from '../abstract.component';
import { Module } from 'projects/common/model/ModuleModel';
import { MainTitle } from '../main-title/main-title.component';

@Component({
  selector: 'reels',
  template: `
    <div *ngIf="!showSideTitle" class="reels-title">
        <main-title [data]="mainTitleData" [moduleId]="module.id" [uniqueId]="module.unique_id"></main-title>
    </div>
    <div class="reels-slider-row" [ngClass]="{'reels-slider-side-title': showSideTitle}">
      <div *ngIf="showSideTitle" class="reels-title">
        <main-title *ngIf="showSideTitle" [data]="mainTitleData" [moduleId]="module.id" [uniqueId]="module.unique_id"></main-title>
      </div>
      <reels-slider *ngIf="module && (module.data?.videos?.length ?? 0) > 0" [trackingParams]="trackingParams" [module]="module"></reels-slider>
    </div>
  `,
  styleUrls: ['./reels.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReelsComponent extends AbstractComponent implements OnInit {
  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() moduleIndex: number;
  @Input() override module: Module<ReelsData>;

  trackingParams: TrackingParameters;
  showSideTitle: boolean = false;
  mainTitleData: MainTitle;

  ngOnInit(): void {
    this.createTrackingParams();
    this.calculateShowSideTitle();
    this.setMainTitleData();
  }

  getModuleId(): string {
    return this.moduleId
  }

  private setMainTitleData(): void {
    this.mainTitleData = {
      title: this.module.title,
      pre_title: this.module.pretitle,
      sub_title: this.module.subtitle,
      more_text: this.module.more_text
    };
  }

  private createTrackingParams(): void {
    this.trackingParams = {
      moduleId: this.moduleId,
      uniqueId: this.uniqueId,
      moduleIndex: this.moduleIndex,
      labelsTracker: this.module?.data?.upa_data?.label || ''
    }
  }

  private calculateShowSideTitle(): void {
    this.showSideTitle = (this.module?.text_position?.includes('SIDE') ?? false) && this.screenType === 'DESKTOP';
  }
}
